// extracted by mini-css-extract-plugin
module.exports = {"modal-2fa-codes__title":"modal-2fa-codes_modal-2fa-codes__title__MQXLh","modal-2fa-codes__form":"modal-2fa-codes_modal-2fa-codes__form__k8qw_"};